export const GET_POSTS = 'GET_POSTS';
export const GET_SLOTS = 'GET_SLOTS';
export const GET_SLOT = 'GET_SLOT';
export const SAVE_SLOT = 'SAVE_SLOT';
export const NO_INCLUDE_CLASSNAME_CONTENT = [
  'Highlights',
  'Home',
  'Plone Site',
];
export const GET_FOOTER_PORTAL = 'GET_FOOTER_PORTAL';
export const GET_HOME_INFO = 'GET_HOME_INFO';
export const GET_PORTAL_NOTICE = 'GET_PORTAL_NOTICE';
export const GET_ANALYTICS_INFO = 'GET_ANALYTICS_INFO';

export const LIST_NEWS_PORTAL = 'LIST_NEWS_PORTAL';
export const RESET_NEWS_PORTAL = 'RESET_NEWS_PORTAL';

export const GET_UNIDADE_NOTICIAS = 'GET_UNIDADE_NOTICIAS';

export const GET_SERVICOS = 'GET_SERVICOS';

export const GET_MPF_PERMISSOES = 'GET_MPF_PERMISSOES';
export const LIST_MPF_PERFIS = 'LIST_MPF_PERFIS';
export const GET_MPF_PERFIS_CATALOGO = 'GET_MPF_PERFIS_CATALOGO';
export const CREATE_MPF_PERFIL = 'CREATE_MPF_PERFIL';
export const UPDATE_MPF_PERFIL = 'UPDATE_MPF_PERFIL';
export const DELETE_MPF_PERFIL = 'DELETE_MPF_PERFIL';

export const GET_MPF_NOTIFICACOES = 'GET_MPF_NOTIFICACOES';
export const GET_MPF_NOTIFICACOES_CONTAGEM = 'GET_MPF_NOTIFICACOES_CONTAGEM';
export const MARCAR_MPF_NOTIFICACAO = 'MARCAR_MPF_NOTIFICACAO';
export const MARCAR_TODAS_MPF_NOTIFICACOES = 'MARCAR_TODAS_MPF_NOTIFICACOES';
export const ARQUIVAR_MPF_NOTIFICACAO = 'ARQUIVAR_MPF_NOTIFICACAO';
export const GET_MPF_MINHA_FILA = 'GET_MPF_MINHA_FILA';
export const GET_MPF_TRANSICOES_DA_NOTICIA = 'GET_MPF_TRANSICOES_DA_NOTICIA';
export const GET_MPF_ALTERACOES_REVISAO = 'GET_MPF_ALTERACOES_REVISAO';

export const NO_INCLUDE_CONTEXT_NAVIGATION = [
  'image',
  'video',
  'audio',
  'file',
  'relatedItems',
];

export const SUBHOME_LAYOUT = 'subhome_view';

export const NEWS_PORTAL_TYPES = ['News', 'News Item', 'Noticia'];

export const NEWS_PUBLIC_STATES = [
  'published',
  'visible',
  'revisao_textual_nacional',
  'revisao_tecnica',
  'revogado',
  'publicado_em_revisao',
  'publicado_aguardando_validacao',
];

// Publicada nacionalmente (capa): a revisão de conteúdo publicado não a tira
// do ar nem da nacional. Espelha ``ESTADOS_NACIONAIS`` do backend.
export const NEWS_NATIONAL_STATES = [
  'published',
  'publicado_em_revisao',
  'publicado_aguardando_validacao',
];

export const NEWS_TITLE_MAX = 120;
export const NEWS_DESCRIPTION_MAX = 160;
